import * as d3 from 'd3';


// 서클이 그려질때 path를 생성하여 서클과 서클을 잇는다.
// d3의 function을 변수에 넣어 사용할 수 있다.
function DrawShapes(elmt, drawable){
  this.svg = d3.select(elmt);
  this.pathArray = [];
  this.path = null;
  this.drawable = !!drawable;
  this.eventListeners = new Map();

  this.lineFunction =
  d3.line()
    .x((d) => {
      return d.x;
    })
    .y((d) => {
      return d.y;
    })
    .curve(d3.curveLinearClosed); // 점을 찍어 라인을 그린 도형을 닫는 기능


  // this가 svg가 되기 때문에 array를 전역으로 뺀다.
  this.mousedown = () => {

    const md = d3.mouse(d3.event.currentTarget);
    // 도형을 사각형으로 제한하기 위해 배열 길이가 3이 넘어가면 도형을 완성시킨다.
    if (this.pathArray.length <= 3) {
      this.pathArray.push({
        'x': md[0],
        'y': md[1]
      });
      this.drawCircle();
    } else {
      this.eraseCurrent();
      this.drawPath();
      this.drawCircle();
      this.fireEvent('finish-drawing', this.pathArray);
    }
  };

  this.doubleClick = () => {

    const tail = this.pathArray[this.pathArray.length - 1];
    const preTail = this.pathArray[this.pathArray.length - 2];
    // 더블 클릭시 배열 끝의 두자리 값이 같다면 하나를 지운다.
    if (tail.x === preTail.x && tail.y === preTail.y) {
      this.pathArray.pop();
    }

    if (this.drawable) {
    // 최종적으로 그려진 도형에 드레그, 서클 길이조절 가능하도록 한다.
      this.path.call(
        d3.drag().on('drag', this.dragPath)
      );
      this.fireEvent('finish-drawing', this.pathArray);
    }
  };

  // 도형을 그리는 동안 svg는 mousemove가 되지 않는다.
  // 그린 후에도 drawable한 상태가 아니기 때문에 mousemove는 무효화 된다.
  // 하지만 Redraw버튼을 클릭한 후에는 다시 drawable한 상태가 되고
  // mousedown이벤트를 활성화 시켜야 하기 때문에
  // mousemove에서 Redraw버튼 사용을 위해 null 처리 해놓았던 mousedown을 다시 활성화 한다.
  this.mousemove = () => {

    this.svg.on('mousedown', this.mousedown); // null 처리 해놓았던 mousedown을 다시 활성화 한다.

    if (this.path !== null) {
      this.path.call(
        d3.drag().on('drag', this.dragPath) // 다시 그린 도형의 드래그기능을 활성화 한다.
      );
    }
  };

  this.rightClick = function() {

    if(this.showonly) return;

    d3.event.preventDefault();
    this.menuItems[0].x = d3.mouse(d3.event.currentTarget)[0];
    this.menuItems[0].y = d3.mouse(d3.event.currentTarget)[1];

    this.contextMenu(this.menuItems);
  };

  // 배열에 담긴 좌표값을 이용하여 서클을 그린다.
  this.drawCircle = () => {
    this.svg
      .selectAll('circle')
      .data(this.pathArray)
      .enter()
      .append('circle')
      .attr('r', 5)
      .attr('cx', (d) => d.x)
      .attr('cy', (d) => d.y)
      .on('mouseover', function () {
        d3.select(this).raise(); // 마우스 오버시 서클을 path보다 높은 z-index로 나타낸다.
      })
      .call(
        d3.drag().on('drag', this.dragCircle)
      );
    this.drawPath();
  };

  // 서클을 드레그할때 동작한다.
  this.dragCircle = (data) => {
    const e = d3.event;
    data.x += e.dx;
    data.y += e.dy;

    this.eraseCurrent(); // 현재 그려진 도형을 모두 지운다.
    this.drawPath(); // path를 다시 그린다.
    this.drawCircle();

    if (this.pathArray.length > 3) {
      this.fireEvent('finish-drawing', this.pathArray);
    }
  };


  // drag path, drag circle
  this.dragPath = () => {
    const e = d3.event;
    this.pathArray.forEach((datum) => {
      datum.x += e.dx;
      datum.y += e.dy;
    });

    this.fireEvent('drag-shape', this.pathArray);

    this.eraseCurrent(); // 현재 그려진 도형을 모두 지운다.
    this.drawPath(); // path를 다시 그린다.
    this.drawCircle();
  };

  // 좌표에 그려진 서클을 path로 이어주는 함수
  this.drawPath = () => {
    this.path = this.svg.append('path').attr('class', 'currentPath');

    this.path
      .attr('d', this.lineFunction(this.pathArray))
      .attr('stroke', 'salmon')
      .attr('fill', 'lightsalmon')
      .attr('opacity', 0.5);
  };

  // 좌표에 그려진 서클을 path로 이어주는 함수
  this.drawPathEmptyFill = (coords) => {
    const aPath = this.svg.append('path');

    aPath
      .attr('d', (d) => {
        return 'M' + coords[0][0] + ' ' + coords[0][1] + ' L ' + coords[1][0] + ' ' + coords[1][1] + ' L ' + coords[2][0] + ' ' + coords[2][1] + ' L ' + coords[3][0] + ' ' + coords[3][1] + ' z';
      })
      .attr('stroke', 'lime')
      .attr('fill', 'none')
      .attr('stroke-width', 3)
      .attr('opacity', 0.7);
  };

  this.drawCurrentMarker = (coordsArr) => {
    coordsArr.forEach(coords => this.pathArray.push({
      'x': coords[0],
      'y': coords[1]
    }));

    this.drawPath();
    this.drawCircle();
  };

  this.drawMarkers = (shapeCoordsArr) => {
    if(shapeCoordsArr){

      shapeCoordsArr.forEach(coords => {
        this.drawPathEmptyFill(coords);
      });
    }

  };

  this.contextMenu = (items) => {
    const width = 70;
    const height = 20;
    const margin = 3;

    this.svg
      .append('g')
      .attr('class', 'context-menu')
      .selectAll('tmp')
      .data(items)
      .enter()
      .append('g')
      .attr('class', 'menu-entry');

    this.svg.selectAll('.menu-entry')
      .append('rect')
      .attr('class', 'menu-rect')
      .attr('x', (d) => {
        return d.x;
      })
      .attr('y', (d, i) => {
        return d.y + (i * height);
      })
      .attr('width', width)
      .attr('height', height);

    this.svg.selectAll('.menu-entry')
      .append('text')
      .attr('class', 'menu-text')
      .attr('fill', 'black')
      .attr('cursor', 'pointer')
      .text((d) => {
        return d.text;
      })
      .attr('x', (d) => {
        return d.x;
      })
      .attr('y', (d, i) => {
        return d.y + (i * height);
      })
      .attr('dy', height - margin) // text height
      .attr('dx', margin) // text margin
      .on('mouseover', function () {
        d3.select(this).raise(); // 마우스 오버시 서클을 path보다 높은 z-index로 나타낸다.
      })
      .on('mousedown', this.contextClick);

  };

  this.contextClick = () => {
    this.svg.on('mousedown', null); // 컨텍스트 메뉴를 사용할 동안 서클 만드는 마우스 이벤트 off.
    this.eraseCurrent(); // remove all
    this.pathArray = []; // init array

    this.svg.select('.context-menu').remove(); // 컨텍스트 메뉴를 닫는다.

  };

  this.addEventListener = (name, listener) => {
    if (!this.eventListeners.has(name)) {
      this.eventListeners.set(name, listener);
    }
  };

  this.removeEventListener = (name) => {
    if (this.eventListeners.has(name)) {
      this.eventListeners.delete(name);
    }
  };

  this.fireEvent = (eventType, payload) => {
    this.eventListeners.forEach((listener, name) => {
      (listener)(eventType, payload);
    });
  };


  // 모든 도형을 지우는 함수
  this.eraseAll = () => {
    const circles = this.svg.selectAll('circle');
    const paths = this.svg.selectAll('path');

    circles.remove();
    paths.remove();
  };

  this.eraseCurrent = () => {
    const circles = this.svg.selectAll('circle');
    const currentPath = this.svg.selectAll('.currentPath');
    circles.remove();
    currentPath.remove();
  };

  this.clear = () => {
    this.pathArray = [];
    this.eraseAll();
  };


  if(this.drawable){
    // mousedown시 좌표값을 배열에 담는다.
    this.svg.on('mousedown', this.mousedown);
    // 더블클릭하면 현재 생성된 모든 도형을 삭제하고 다시 그린다.
    this.svg.on('dblclick', this.doubleClick);
    this.svg.on('contextmenu', this.rightClick);
    this.svg.on('mousemove', this.mousemove);
    // 우클릭을 하여 다시그리기 기능을 만든다.
    this.menuItems = [{ 'text': 'Redraw'} ];
  }

}

export default DrawShapes;
